import { render, staticRenderFns } from "./officialStoreApp.vue?vue&type=template&id=0673ee50&"
import script from "./officialStoreApp.vue?vue&type=script&lang=js&"
export * from "./officialStoreApp.vue?vue&type=script&lang=js&"
import style0 from "./officialStoreApp.vue?vue&type=style&index=0&id=0673ee50&prod&lang=css&"
import style1 from "./officialStoreApp.vue?vue&type=style&index=1&id=0673ee50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports